import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { ResponsiveService } from '../responsive.service';

@Injectable()
export class ResponsiveGuard {
  constructor(private readonly router: Router, private readonly responsiveService: ResponsiveService) {}

  public canActivate(): boolean | UrlTree {
    return this.responsiveService.isDesktopDevice ? true : this.router.parseUrl('/app/responsive-error');
  }

  public canActivateChild(): boolean | UrlTree {
    return this.canActivate();
  }
}
